module.exports = __webpack_public_path__ + "static/media/de.2afe429a.svg";